import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { NbDialogService } from '@nebular/theme';
import { ModalWarningComponent } from '@app/shared/modal/components/modal-warning/modal-warning.component';

import { UserApiService } from './user.service';

@Injectable()
export class BasicAuthInterceptor implements HttpInterceptor {
    private isRedirecting = false;
    private hasShownSessionExpiredModal = false;
    private isSessionExpiredModalOpen = false;

    constructor(
        private authService: UserApiService,
        private router: Router,
        private dialogService: NbDialogService,
      ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const currentUser = this.authService.auth;
    if (currentUser && this.authService.auth.access_token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.authService.auth.access_token}`,
        },
      });
    }

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        const errorBody = error?.error || {};
        const expiredToken =
          errorBody?.error === 'EXPIRED_TOKEN' ||
          errorBody?.error_description === 'EXPIRED_TOKEN' ||
          (errorBody?.message || '').toString().toLowerCase().includes('token has expired');
        if (error && (error.status === 401 || expiredToken)) {
          this.handleSessionExpired(true);
        }
        return throwError(error);
      }),
    );
  }

  private handleSessionExpired(showModal: boolean = false): void {
    if (this.isRedirecting || this.isSessionExpiredModalOpen) {
      return;
    }

    if (showModal && !this.hasShownSessionExpiredModal) {
      this.hasShownSessionExpiredModal = true;
      this.isSessionExpiredModalOpen = true;
      this.dialogService
        .open(ModalWarningComponent, {
          context: {
            title: 'Sesion expirada',
            message: 'Su sesion ha expirado. Debe iniciar sesion nuevamente.',
            showCancel: false,
            confirmText: 'Aceptar',
          },
          closeOnBackdropClick: false,
          closeOnEsc: false,
        })
        .onClose.subscribe(() => {
          this.isSessionExpiredModalOpen = false;
          this.performLogoutAndRedirect();
        });
      return;
    }

    this.performLogoutAndRedirect();
  }

  private performLogoutAndRedirect(): void {
    this.isRedirecting = true;

    try {
      this.authService.logOut();
    } catch (_) {
      // noop
    }

    try {
      sessionStorage.clear();
      localStorage.removeItem('login_response');
    } catch (_) {
      // noop
    }

    const currentUrl = this.router.url || '';
    if (currentUrl !== '/') {
      this.router.navigate(['/'], {
        queryParams: { sessionExpired: 'true' },
      }).finally(() => {
        this.isRedirecting = false;
      });
    } else {
      this.isRedirecting = false;
    }
  }
}
